import React, { useEffect } from 'react'
import styled from 'styled-components'
import SideBarBtn from './SideBarBtn'
import { ReactComponent as ChatIcon } from "../../Assets/iconsv2/sidebar/Chats.svg"
import { ReactComponent as ChatIconFilled } from "../../Assets/iconsv2/sidebar/ChatsFilled.svg"
import { ReactComponent as CallIcon } from "../../Assets/iconsv2/sidebar/Calls.svg"
import { ReactComponent as CallIconFilled } from "../../Assets/iconsv2/sidebar/CallsFilled.svg"
import { ReactComponent as Contacts } from "../../Assets/iconsv2/sidebar/Contacts.svg"
import { ReactComponent as ContactsFilled } from "../../Assets/iconsv2/sidebar/ContactsFilled.svg"
import { ReactComponent as Tools } from "../../Assets/iconsv2/sidebar/Tools.svg"
import { ReactComponent as Notices } from "../../Assets/iconsv2/sidebar/Notices.svg"
import { ReactComponent as NoticesUnread } from "../../Assets/iconsv2/sidebar/NoticesActive.svg"
import { ReactComponent as Settings } from "../../Assets/iconsv2/sidebar/Settings.svg"
import { ReactComponent as Speaker } from "../../Assets/iconsv2/sidebar/Speaker.svg"
import { ReactComponent as SpeakerFilled } from "../../Assets/iconsv2/sidebar/SpeakerFilled.svg"
import { ReactComponent as Meetings } from "../../Assets/iconsv2/sidebar/Meetings.svg";
import { ReactComponent as MeetingsFilled } from "../../Assets/iconsv2/sidebar/MeetingsFilled.svg";

import ProfileButton from './ProfileButton'
import { useTranslate } from '@tolgee/react';
import { CALLS, CHATS, CONTACTS, MEETINGS, SETTINGS, TOOLS, CONFERENCES } from '../../Constants/constantValues'
import { useLinksquaredService } from '../../Context/LinksquaredContext'
import LocalStorage from '../../Helpers/LocalStorage'



const SideBar = ({ toggle, setToggle, handleOpenLinksuaredMessages }) => {

    const { t } = useTranslate();
    const { linksquaredUnread } = useLinksquaredService();

    const handleSelectMenuOption = (option) => {
        setToggle(option);
        LocalStorage.setSidebar(option)
    }

    useEffect(() => {
        let option = LocalStorage.getSidebar();
        if (option && option !== "") {
            setToggle(option)
        }
    }, [])


    return (
        <SidebarContainer>
            <ProfileButton
                onClick={() => handleSelectMenuOption(SETTINGS)}
            />
            <OptionList>
                <SideBarBtn
                    title={t('general.chats')}
                    icon={<ChatIcon />}
                    selectedIcon={<ChatIconFilled />}
                    selected={toggle === CHATS}
                    onClick={() => handleSelectMenuOption(CHATS)}
                />
                <SideBarBtn
                    title={t('general.calls')}
                    icon={<CallIcon />}
                    selectedIcon={<CallIconFilled />}
                    selected={toggle === CALLS}
                    onClick={() => handleSelectMenuOption(CALLS)}
                />
                <SideBarBtn
                    title={t('general.contacts')}
                    icon={<Contacts />}
                    selectedIcon={<ContactsFilled />}
                    selected={toggle === CONTACTS}
                    onClick={() => handleSelectMenuOption(CONTACTS)}
                />
                <SideBarBtn
                    title={t('general.meetings')}
                    icon={<Meetings />}
                    selectedIcon={<MeetingsFilled />}
                    selected={toggle === MEETINGS}
                    onClick={() => handleSelectMenuOption(MEETINGS)}
                />
                <SideBarBtn
                    title={t({ key: 'general.conferences', defaultValue: 'Conferences' })}
                    icon={<Speaker />}
                    selectedIcon={<SpeakerFilled />}
                    selected={toggle === CONFERENCES}
                    onClick={() => handleSelectMenuOption(CONFERENCES)}
                />
                <SideBarBtn
                    title={t({ key: 'general.tools', defaultValue: 'Tools' })}
                    icon={<Tools />}
                    selectedIcon={<Tools />}
                    selected={toggle === TOOLS}
                    onClick={() => handleSelectMenuOption(TOOLS)}
                />
                <SideBarBtn
                    title={t('general.updates')}
                    icon={linksquaredUnread ? <NoticesUnread /> : <Notices />}
                    onClick={() => handleOpenLinksuaredMessages()}
                />
            </OptionList>

            <BottomButtons>
                <SideBarBtn
                    selected={toggle === SETTINGS}
                    icon={<Settings />}
                    selectedIcon={<Settings />}
                    onClick={() => handleSelectMenuOption(SETTINGS)}
                />
            </BottomButtons>

        </SidebarContainer>
    )
}

export default SideBar

const SidebarContainer = styled.div`
display:flex;
flex-direction:column;
width:100%;
min-width:70px;
width:fit-content;
max-width:110px;
padding: 8px 8px 24px 8px;
gap:32px;
background:${({ theme }) => theme.sidebar.background};
border-right:1px solid ${({ theme }) => theme.sidebar.borderColor};
`
const OptionList = styled.div`
display:flex;
flex-direction:column;
width:100%;
gap:16px;
`

const BottomButtons = styled.div`
display: flex;
flex-direction: column;
width: 100%;
gap: 16px;
margin-top: auto;
`
